import React, { FC } from 'react';

import clsx from 'clsx';
import { omit } from 'lodash';
import HelperText from '../HelperText';
import styles from './radioButton.module.sass';

export interface RadioButtonProps {
  error?: string;
  helperText?: string;
  valueKey: string;
  options: RadioOptions[];
  rootProps?: React.HtmlHTMLAttributes<HTMLDivElement>;
  otheFieldProps?: Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'type' | 'name' | 'value' | 'id' | 'onChange'
  >;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, val: any) => void;
  selectedValue?: string | number;
  nafAcademy?: boolean;
  userEdit?: boolean;
}

export interface RadioOptions {
  name: string;
  value: any;
  id: string;
  labelClasses?: string;
  fieldClass?: string;
}

const RadioButton: FC<RadioButtonProps> = props => {
  const {
    options,
    rootProps,
    valueKey,
    error,
    helperText,
    otheFieldProps,
    onChange,
    selectedValue,
    nafAcademy,
    userEdit,
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange?.(e, e.currentTarget.value);
  if (nafAcademy) {
    return (
      <>
        <div
          className={clsx(rootProps?.className, styles.radioRootNaf)}
          {...omit(rootProps, 'className')}
        >
          {options.map(o => {
            return (
              <label
                key={o.id}
                className={clsx(
                  o.labelClasses,
                  userEdit ? styles.radioLabelWhite : styles.radioLabelRight,
                )}
                htmlFor={o.id}
              >
                <div className={userEdit ? styles.radioWrapperWhite : styles.radioWrapperLeft}>
                  <input
                    type="radio"
                    name={valueKey}
                    value={o.value}
                    id={o.id}
                    className={styles.radioField}
                    onChange={handleChange}
                    {...otheFieldProps}
                    checked={selectedValue === o.value}
                  />
                  <span className={clsx(o.fieldClass, styles.radioIcon)} />
                </div>
                {o.name}
              </label>
            );
          })}
        </div>
        {(helperText || error) && <HelperText error={!!error}>{error ?? helperText}</HelperText>}
      </>
    );
  }
  return (
    <>
      <div
        className={clsx(rootProps?.className, styles.radioRoot)}
        {...omit(rootProps, 'className')}
      >
        {options.map(o => {
          return (
            <label key={o.id} className={clsx(o.labelClasses, styles.radioLabel)} htmlFor={o.id}>
              {o.name}
              <div className={styles.radioWrapper}>
                <input
                  type="radio"
                  name={valueKey}
                  value={o.value}
                  id={o.id}
                  className={styles.radioField}
                  onChange={handleChange}
                  {...otheFieldProps}
                  checked={selectedValue === o.value}
                />
                <span className={clsx(o.fieldClass, styles.radioIcon)} />
              </div>
            </label>
          );
        })}
      </div>
      {(helperText || error) && <HelperText error={!!error}>{error ?? helperText}</HelperText>}
    </>
  );
};

export default RadioButton;
